import ChangeScheduleAppointment from './containers/ChangeSchedule'
import ActionContinue from './containers/Continue'
import PendingOfferCustomer from './containers/PendingOfferCustomer'
import PendingSignature from './containers/PendingSignature'

export const MasterAction = {
  'signed': ({ application }) => <ActionContinue application={application} />,
  'created': ({ application }) => <ActionContinue application={application} />,
  'pending-signature': ({ application }) => <PendingSignature application={application} />,
  'change-schedule-appointment-cc': ({ application }) => <ChangeScheduleAppointment application={application} />,
  'waiting-for-customer-approval': ({ application }) => <PendingOfferCustomer application={application} />,
}
